import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterPerfilOpciones from 'views/security/perfilopciones/filterPerfilOpciones'; // Importing filter options component
import TablePerfilOpciones from 'views/security/perfilopciones/tablePerfilOpciones'; // Importing table component for profile options
import DetailsPerfilOpciones from 'views/security/perfilopciones/detailsPerfilOpciones'; // Importing details component for profile options
import RecordPerfilOpciones from 'views/security/perfilopciones/recordPerfilOpciones'; // Importing record component for profile options
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the PerfilOpcionesView.
 * @extends JetView
 */
export default class PerfilOpcionesView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section layout containing PlayersView and other components
        const right = {
            type: 'wide',
            rows: [PlayersView, DetailsPerfilOpciones, RecordPerfilOpciones],
        };

        // Toolbar configuration with pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 15, // Number of items per page
                },
            ],
        };

        // Left section layout containing toolbar and table
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Perfil Opciones') }, // Label for the toolbar
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Icon for closing the view
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigation on click
                                },
                            ],
                        },
                    ],
                },
                TablePerfilOpciones, // Table component for profile options
                toolbar, // Including the toolbar
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide',
            responsive: true,
            css: 'out',
            cols: [
                left, // Left section layout
            ],
        };
    }
}

// FILE DOCUMENTED
